//TODO pulizia file
import React, { useState, useContext, useEffect} from 'react';

import {OverlayContext} from '../../contexts/OverlayContext';

import {OzContainer, OzButton, OzSelect, OzUserTag, OzCol, OzRow, OzInput, OzCard} from "@ozwol/webui";

import CustomizationfeesService from '../../services/CustomizationfeesService';
import UsersService from '../../services/UsersService';

import CardHeaderTitle from '../../components/CardHeaderTitle';
import ErrorMessage from '../../components/ErrorMessage';
import HealthyWrapper from '../../components/HealthyWrapper';
import Datepicker from '../../ui/Datepicker/Datepicker';

import {formatError, testValidField, getIsoDate, changeDate} from '../../helpers';



const InsiderCustomizationfeesModalNew = () => {
  const {removeOverlay} = useContext(OverlayContext);
  const [item, setItem] = useState({
		day: getIsoDate(new Date()).split("T")[0]
	});
  const [ownerUuid, setOwnerUuid] = useState();

  const [disabled, setDisabled] = useState(true);
  // const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [fetchError, setFetchError] = useState(false);

  const [searchUsers, setSearchUsers] = useState("");
  const [listUsers, setListUsers] = useState([]);
  const [periods, setPeriods] = useState([]);
  const [periodStart, setPeriodStart] = useState(null);
  const [periodEnd, setPeriodEnd] = useState(null);


  const save = () => {
    CustomizationfeesService.adminCreate(item, ownerUuid).then((response) => {
      window.location.replace("/insider/customizationfees/");
    }).catch((error) => {
      setErrorMessage(formatError(error));
    });

  };

  useEffect(() => {
    setErrorMessage(null);
    let valid = true;
    if(item){
      if(!testValidField(ownerUuid, true)){
        valid = false;
      }
      if(!testValidField(item.description, true)){
        valid = false;
      }
      if(!testValidField(item.quantity, true)){
        valid = false;
      }
      if(!testValidField(item.price, true)){
        valid = false;
      }
      if(!testValidField(item.day, true)){
        valid = false;
      }
    }else{
      valid = false;
    }
    setDisabled(!valid);
  }, [item, ownerUuid]);

  useEffect(() => {
    UsersService.adminList({
      "search": searchUsers.length > 2 ? searchUsers : "",
    }).then((response) => {
      setListUsers(response.result);
    }).catch((error) => {
      setFetchError(formatError(error));
    });
  }, [searchUsers]);

  useEffect(() => {
		UsersService.adminListPeriods({
			"limit": 0
		}).then((response) => {
			setPeriods(response.result);
		}).catch((error) => {
			setFetchError(formatError(error));
		});     
}, []);

  return (
    <OzContainer size="medium">
      
      <HealthyWrapper error={fetchError}>
        <OzCard
          headerLeft={
            <CardHeaderTitle title={"Add customization fee"} />
          }
          headerSeparator={true}
          footerLeft={<OzButton variant={"chetwodeblue-o"} onClick={() => removeOverlay("form")}>Back</OzButton>}
          footerRight={<OzButton onClick={() => save()} variant={"chetwodeblue"} disabled={disabled}>Save</OzButton>}
        >

          <OzRow>
            <OzCol widthmd="10">
              <OzSelect
                label="Owner"
                width="100%"
                placeholder="Owner"
                selected={ownerUuid ? ownerUuid : null}
                highlighted={ownerUuid}
                values={listUsers.map((item) => ({
                  "name": <OzUserTag
                      name={item.givenName + " " + item.familyName}
                      company={item.company}
                      direction={"horizontal"}
                    />,
                  "value": item.uuid,
                }))}
                onChange={(val) => {
                  setOwnerUuid(val);   
									let period = periods.filter(item => item.ownerUuid === val)[0];
                  let tempItem = {...item};
                  tempItem.day = new Date(period.startDate);
                  setItem(tempItem);
									setPeriodStart(period.startDate);
									setPeriodEnd(period.endDate);
                }}
                maxHeight={"200px"}
                searchable={true}
                search={searchUsers}
                onSearch={(val) => setSearchUsers(val)}
                required
              />
            </OzCol>
            <OzCol widthmd="2">
              <Datepicker
                label="Day"
								type="single"
								compact={true}
								buttonLabel={<span className="material-symbols-outlined">calendar_month</span>}
								onChange={(startVal) => {
                  let tempItem = {...item};
                  tempItem.day = new Date(startVal)
                  setItem(tempItem);
								}}
								value={item.day ? new Date(item.day) : null}
								minDate={periodStart ? changeDate(periodStart, -1, "days") : null}
								maxDate={periodEnd}
							/>
            </OzCol>
            <OzCol widthmd="2">
              <OzInput
                label="Quantity"
                width="100%"
                value={item && item.quantity ? item.quantity : ""}
                highlighted={item && item.quantity && item.quantity.length > 0}
                placeholder="Quantity"
                onChange={(val) => {
                  let tempItem = {...item};
                  tempItem.quantity = val;
                  setItem(tempItem);
                }}
                required
              />
            </OzCol>
            <OzCol widthmd="2">
              <OzInput
                label="Price"
                width="100%"
                value={item && item.price ? item.price : ""}
                highlighted={item && item.price && item.price.length > 0}
                placeholder="Price"
                onChange={(val) => {
                  let tempItem = {...item};
                  tempItem.price = val;
                  setItem(tempItem);
                }}
                required
              />
            </OzCol>
            <OzCol widthmd="8">
              <OzInput
                label="Description"
                width="100%"
                value={item && item.description ? item.description : ""}
                highlighted={item && item.description && item.description.length > 0}
                placeholder="Description"
                onChange={(val) => {
                  let tempItem = {...item};
                  tempItem.description = val;
                  setItem(tempItem);
                }}
                required
              />
            </OzCol>
            
          </OzRow>
          <ErrorMessage>
            {errorMessage}
          </ErrorMessage>
          
        
        </OzCard>
      </HealthyWrapper>
    </OzContainer>
  );

}
export default InsiderCustomizationfeesModalNew;
